export function isNativeApp() {
  return window.webkit?.messageHandlers?.loops != null
}

export function notifyNative(type, payload = {}) {
  window.webkit?.messageHandlers?.loops?.postMessage({ type, ...payload })
}

export function nativeNavigate(neuronId, title) {
  if (!isNativeApp()) return false
  notifyNative("navigate", { neuronId: String(neuronId), title: title || "" })
  return true
}

export function nativeNavigateHome() {
  if (!isNativeApp()) return false
  notifyNative("navigateHome")
  return true
}
